import { dermNumber } from './../data/constants';
import { PATHNAME_TO_PAGE_ID_MAP, PAGE_ID, Env, HOST, SDM_PHARMA, MONDO_PHARMA } from '@/data/constants';
import { toLower } from './str-util';
import { getEnvironment, isPharmaprixBanner } from './utils';

// Specifically fomats the string param with key 'queryParam '
export function formatQueryParam(queryParam: string, searchText: string): string {
  if (queryParam) return queryParam; // Note: For search PLP, if there is a query param, it will already include the search text
  return searchText;
}

const getCategoryLevel = (): { level1Category: string } => {
  const pathNames = window.location.pathname.split('/');
  const level1Category = pathNames.length > 3 ? pathNames[3] : '';
  return { level1Category };
};

export interface KeyMap {
  q: string;
  sort: string;
  page: string;
  text: string;
}

const getQueryParamKeyMap = (key: string): string | undefined => {
  const keyMap: KeyMap = {
    q: 'queryParam',
    sort: 'sortBy',
    page: 'page',
    text: 'searchText',
  };
  return keyMap[key as keyof KeyMap];
};

export function getDefaultStringParameters() {
  const categoryId = window.location.pathname.split('/c/')[1];
  const { level1Category } = getCategoryLevel();

  const defaultStringParameters = window.location.search.replace('?', '').split('&');
  const formattedDefaultStringParameters = defaultStringParameters.reduce((acc, queryParam) => {
    let queryParams: any = { ...acc };
    if (queryParam) {
      const [queryParamKey, queryParamValue] = queryParam.split('=');
      const queryParamKeyMap = getQueryParamKeyMap(queryParamKey);
      if (queryParamKeyMap) {
        queryParams[queryParamKeyMap] = decodeURIComponent(queryParamValue);
      }
    }
    return queryParams;
  }, {});
  return {
    formattedDefaultStringParameters,
    categoryId,
    level1Category,
  };
}

export const getQueryParams = (queryParam: string): string | null => {
  const params = new URLSearchParams(window.location.search);
  return params.has(queryParam) ? params.get(queryParam) : null;
};

export const getContentfulPreviewHeaders = (query: { preview?: 'true'; dateTime?: string }): Record<string, string> => {
  const headers: Record<string, string> = {
    'x-preview': query.preview || 'false',
    'x-preview-datetime': query.dateTime ?? new Date().toISOString(),
  };

  return headers;
};

export const getPathnameFromUrl = (url: string): string => {
  if (url === '/') {
    return '';
  }

  const queryStringIndex = url.indexOf('?');
  const pathname = queryStringIndex !== -1 ? url.slice(0, queryStringIndex) : url;

  if (pathname.startsWith('/')) {
    return pathname.slice(1);
  }

  return pathname;
};

export const getPageIdFromPathname = (pathname = ''): string => {
  return PATHNAME_TO_PAGE_ID_MAP[toLower(pathname)] || PAGE_ID.LANDING;
};

export function formatLink(link: string, isPhxBanner?: boolean, env?: number): string;
export function formatLink(link: null | undefined, isPhxBanner?: boolean, env?: number): undefined;
export function formatLink(link: string | null | undefined, isPhxBanner?: boolean, env?: number): string | undefined;

/** Turns URL into absolute URL if it is relative */
export function formatLink(
  link: string | null | undefined,
  isPhxBanner?: boolean,
  environment?: number
): string | undefined {
  if (link === undefined || link === null) {
    return undefined;
  } else if (/^http(s)?:\/\//.test(link)) {
    return link;
  }

  const hasSlash = link.startsWith('/');
  const href = hasSlash ? link : `/${link}`;
  const isPharmaprix = isPhxBanner ?? isPharmaprixBanner();
  const env = environment ?? getEnvironment();

  if (env === Env.Prod) {
    return `https://${isPharmaprix ? HOST.PHX : HOST.SDM}${href}`;
  } else if (env === Env.Uat) {
    return `https://${isPharmaprix ? HOST.PHX_UAT : HOST.SDM_UAT}${href}`;
  } else if (env === Env.Local) {
    return `https://${HOST.LOCAL}${href}`;
  }

  return link;
}

export const getRefillHref = (locale: string, isPhxBanner: boolean) => {
  if (isPhxBanner) {
    return `${MONDO_PHARMA}/${locale}/Account/LogIn`;
  }
  return `${SDM_PHARMA}/${locale}`;
};

export const getStoreOrFlyerHref = (locale: string, storeOrFlyer: string, isPhxBanner: boolean) => {
  if (isPhxBanner) {
    return `${HOST.PHX_HOME}/${locale}/${storeOrFlyer}`;
  }
  return `${HOST.SDM_HOME}/${locale}/${storeOrFlyer}`;
};
